import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  OnInit,
} from '@angular/core';
import { SideMenuService } from '../../services/side-menu.service';
import { MeService } from 'src/app/me/services/me.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideMenuComponent implements OnInit, AfterViewInit {
  @HostBinding('class.collapsed') collapsed = false;
  @HostBinding('class.opened') opened = true;

  public navigationLinks = [];
  public isCollapsable = false;

  constructor(
    private elementRef: ElementRef,
    private sideMenuService: SideMenuService,
    private cdr: ChangeDetectorRef,
    private meService: MeService
  ) {}

  ngOnInit() {
    this.meService.getFullProfile()?.subscribe();
    this.sideMenuService.isCollapsable$.subscribe(
      (collapsable) => (this.isCollapsable = collapsable)
    );

    this.sideMenuService.state$
      .pipe(untilDestroyed(this))
      .subscribe((state) => {
        this.opened = state.opened;
        this.collapsed = state.collapsed;
        this.cdr.markForCheck();
      });
  }

  ngAfterViewInit() {
    this.sideMenuService.setSideMenuElementRef(this.elementRef);
  }

  toggleCollapsed() {
    this.sideMenuService.collapsedToggle();
  }

  onNavItemClicked() {
    this.sideMenuService.setDefault();
  }
}
